<template>
    <div>
        <pxkeji-rightHeader />

        <div class="pxkeji-right-box">
            <a-form class="ant-advanced-search-form">
                <a-row :gutter="24">
                    <a-col :span="5">
                        <a-form-item label="用户信息">
                            <a-input placeholder="请输入用户名/姓名/手机号/身份证号" v-model="where.keyword.name" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="申请时间">
                            <a-range-picker
                                    format="YYYY-MM-DD"
                                    :placeholder="['开始时间', '结束时间']"
                                    @change="onTimeChange"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="开票时间">
                            <a-range-picker
                                    format="YYYY-MM-DD"
                                    :placeholder="['开始时间', '结束时间']"
                                    @change="onCreateTimeChange"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="5">
                        <a-form-item label="发票状态">
                            <a-select defaultValue v-model="where.keyword.status">
                                <a-select-option value>全部</a-select-option>
                                <a-select-option value="1">申请中</a-select-option>
                                <a-select-option value="0">已完成</a-select-option>
                                <a-select-option value="4">已驳回</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="24">
                    <a-col :span="10">
                        <a-form-item label="所在地区">
                            <a-cascader
                                    :options="areas"
                                    placeholder="请选择所在地区"
                                    change-on-select
                                    @change="onAreachange"
                                    :default-value="areaList"
                                    :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="7">
                        <a-form-item label="用户组">
                            <a-select
                                    show-search
                                    v-model="where.keyword.groupId"
                                    :filter-option="filterOption"
                                    allowClear
                                    @change="groupChanged"
                            >
                                <a-select-option
                                        :value="info.id"
                                        v-for="(info, index) in grouplist"
                                        :key="index"
                                >{{info.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="5">
                        <a-form-item label="单位名称">
                            <a-input placeholder="请输入" v-model="where.keyword.company"/>
                        </a-form-item>
                    </a-col>
                </a-row> 
                <a-row :gutter="24">
                    <a-col :span="5">
                        <a-form-item label="发票抬头">
                            <a-select defaultValue v-model="where.keyword.titleType">
                                <a-select-option value>全部</a-select-option>
                                <a-select-option value="2">个人</a-select-option>
                                <a-select-option value="1">企业</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="5">
                        <a-form-item label="纳税人识别号">
                            <a-input placeholder="请输入纳税人识别号" v-model="where.keyword.taxNo" />
                        </a-form-item>
                    </a-col>

                    <a-col :span="4" :style="{ textAlign: 'left' }">
                        <a-button type="primary" @click="searchList" v-btnlimit="'发票列表-搜索'">搜索</a-button>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <div class="pxkeji-right-box">
            <pxkeji-btn name="导出" class="pxkeji_basic_btn" @click="uploadExcel()" type="primary" v-btnlimit="'发票列表-导出'" />
            <a-table
                    :columns="list.columns"
                    rowKey="id"
                    :pagination="list.pagination"
                    @change="onChange"
                    :dataSource="list.datas"
                    :loading="isloading"
                    :locale="{emptyText:'暂无数据'}"
            >

      <span slot="titleType" slot-scope="titleType">
          <span v-if="titleType==1">企业</span>
          <span v-else-if="titleType==2">个人</span>
        </span>
        <span slot="status" slot-scope="status">
          <span v-if="status==4">已驳回</span>
          <span v-else-if="status==0">已完成</span>
          <span v-else-if="status==1">申请中</span>
        </span>
                <span slot="action" slot-scope="info">
          <pxkeji-btn v-if="info.status!=4" name="驳回" size="small" @click="changeStatus(info.id)" type="primary" v-btnlimit="'发票列表-驳回'" />
        </span>
            </a-table>
            <div class="totalbox" style="float: left;">
                <div>
                    <span>共有：{{list.pagination.total}}条数据</span>
                </div>
            </div>
        </div>




    </div>
</template>
<script>
    var that;


    const columns = [
        {
            dataIndex: "id",
            key: "id",
            align: "center",
            title: "序号",
        },
        // {
        //     dataIndex: "title",
        //     key: "title",
        //     align: "center",
        //     title: "抬头",
        // },

        {
            dataIndex: "titleType",
            key: "titleType",
            align: "center",
            title: "发票抬头",
            scopedSlots: { customRender: "titleType" },

        },

        {
            dataIndex: "userName",
            key: "userName",
            align: "center",
            title: "开票人",
        },
        {
            dataIndex: "orderPrice",
            key: "orderPrice",
            align: "center",
            title: "开票金额",
        },
        {
            dataIndex: "email",
            key: "email",
            align: "center",
            title: "收票邮箱",

        },
        {
            dataIndex: "addTime",
            key: "addTime",
            align: "center",
            title: "开票日期",

        },
     /*   {
            dataIndex: "telephone",
            key: "telephone",
            align: "center",
            title: "电话",

        },*/
        {
            dataIndex: "companyName",
            key: "companyName",
            align: "center",
            title: "公司名称",

        },
        {
            dataIndex: "taxNo",
            key: "taxNo",
            align: "center",
            title: "纳税人识别号",

        },
        {
            dataIndex: "status",
            key: "status",
            align: "center",
            title: "状态",
            scopedSlots: { customRender: "status" },

        },
        {
            title: "操作",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "action" },
        },

    ];

    export default {
        name: "couponlist",
        data() {
            return {
                grouplist: [],//2021 11 01
                areas:[],//2021 11 01
                areaList: [],//2021 11 01
                list: {
                    columns, //表头
                    datas: [], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10, //页容
                    },
                },
                addedit: {
                    title: "",
                    info: {},
                    id: 0,
                    visible: false,
                },
                where: {
                    //查询条件
                    keyword: {
                        //搜索条件
                        name: "",
                        startTime: "",
                        endTime: "",
                        taxNo:"",
                        titleType:"",
                        // 2021 11 01 start
                        company:"", 
                        groupId:"", 
                        province:'',
                        city:'',
                        area:'',
                        // 2021 11 01 end
                    },
                },
                selectRows: [], //选中项编号
                isloading: false,
                visible: false, //弹框

            };
        },
        components: {

        },
        mounted: function () {
            this.$nextTick(function () {
                that = this;
                this.GetList();
                this.getarea(); //2021 11 01
                this.getgrouplist();//2021 11 01
            });
        },
        watch: {
            selectRows: function () {
                //console.log("watch", val);
            },
        },
        methods: {
            // 2021 11 01 start
            onAreachange(v){
                  if(v[0]){
                    this.where.keyword.province=v[0];
                  }else{
                    this.where.keyword.province='';
                  }
                  if(v[1]){
                    this.where.keyword.city=v[1];
                  }else{
                    this.where.keyword.city='';
                  }
                  if(v[2]){
                    this.where.keyword.area=v[2];
                  }else{
                    this.where.keyword.area='';
                  }
              },
            getarea(){
                this.areas=this.$api.city.city;
            },
            groupChanged(v) {
              this.where.keyword.groupId = v; 
            },
            getgrouplist() {
              this.isloading = true;
              this.$api.usergroup
                .getAll()
                .then(res => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.grouplist = res.data;
                  } else {
                    this.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                  this.error();
                });
            },
            filterOption(input, option) {
             return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            },
            // 2021 11 01 end
            uploadExcel() {
                // 2021 11 01 start
                if(!this.where.keyword.groupId){
                    this.where.keyword.groupId="";
                }
                // 2021 11 01 end
                window.location.href = this.$api.excel.exportInvoice(this.where.keyword.name,this.where.keyword.startTime,this.where.keyword.endTime,
                    this.where.keyword.taxNo,this.where.keyword.titleType,this.where.keyword.startTimeCreate,this.where.keyword.endTimeCreate,this.where.keyword.status,this.where.keyword.company, this.where.keyword.groupId, this.where.keyword.province,this.where.keyword.city,this.where.keyword.area); //2021 11 01
            },
            onTimeChange(date, dateString) {
                this.where.keyword.startTime = dateString[0];
                this.where.keyword.endTime = dateString[1];
            },
            changeStatus(id){
                this.$api.order.changeInvoiceStatus(id,)
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.$message.success("操作成功");
                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            GetList() {
                // 2021 11 01 start
                if(!this.where.keyword.groupId){
                    this.where.keyword.groupId="";
                }
                // 2021 11 01 end
                this.$api.order.getInvoicePageList(this.list.pagination.current,this.list.pagination.defaultPageSize,
                    this.where.keyword.name,this.where.keyword.startTime,this.where.keyword.endTime,
                    this.where.keyword.taxNo,this.where.keyword.titleType,this.where.keyword.startTimeCreate,this.where.keyword.endTimeCreate,this.where.keyword.status,this.where.keyword.company, this.where.keyword.groupId, this.where.keyword.province,this.where.keyword.city,this.where.keyword.area)//2021 11 01
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.list.datas = res.data.records;
                            this.list.pagination.total = Number(res.data.total);
                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });

            },
            onChange(page) {
                //页面切换回调
                this.list.pagination.current = page.current;
                this.GetList();
            },

            clearRows() {
                //清空选中项
                this.selectRows = [];
            },
            searchList() {
                this.list.pagination.current = 1;
                this.GetList();
            },


            /*禁用启用 */



        },
    };
</script>

<style>
    .ant-advanced-search-form .ant-form-item {
        display: flex;
    }

    .ant-advanced-search-form .ant-form-item-control-wrapper {
        flex: 1;
    }

    #components-form-demo-advanced-search .ant-form {
        max-width: none;
    }

    #components-form-demo-advanced-search .search-result-list {
        margin-top: 16px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #fafafa;
        min-height: 200px;
        text-align: center;
        padding-top: 80px;
    }
</style>

